import { c as _c } from "react/compiler-runtime";
import Section from "@components/Section";
import { ComponentSectionsBudgetCheckForm } from "@lib/generated/graphql";
import EmbeddedBudgetCheck from "@modules/homepage/components/EmbeddedBudgetCheck";
import { FC } from "react";
interface BudgetCheckFormEmbeddedSectionProps {
  data: ComponentSectionsBudgetCheckForm;
}
export const BudgetCheckFormEmbeddedSection: FC<BudgetCheckFormEmbeddedSectionProps> = t0 => {
  const $ = _c(6);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      variant: "neutral_12"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== data) {
    t2 = {
      ...data,
      background: t1
    };
    $[1] = data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const section = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="col-span-12 m:col-span-8 m:col-start-3 l:col-span-6 l:col-start-4"><EmbeddedBudgetCheck /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== section) {
    t4 = <Section section={section} className="py-3s m:py-2m my-s m:my-3s grid grid-cols-12">{t3}</Section>;
    $[4] = section;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default BudgetCheckFormEmbeddedSection;